import {dateFilterParams} from '../../views/components/ag-grid/filter-params/DateComparator';

export default [
  {
    headerName: 'Quote',
    tooltipField: 'OraQuote_FK',
    tooltipComponentParams: { field: 'QuoteURL' },
    cellRenderer: 'CellRendererButton',
    cellClass: 'flex justify-start',
    minWidth: 135,
    cellRendererParams(params) {
      return {
        buttonTxt: 'ViewQuote',
        column: 'QuoteURL',
        backGroundColour: params.data.BtnBkGround,
        borderColour: params.data.BtnBorder,
        fontColour: params.data.BtnFontClr,
      }
    },
  },
  {
    headerName: 'DateOfRenewal',
    headerClass: 'header-text-wrap',
    field: 'DateOfRenewal',
    tooltipField: 'DateOfRenewal',
    tooltipComponentParams: { field: 'DateOfRenewal', isDate: true },
    filter: 'agDateColumnFilter',
    minWidth: 100,
    cellRenderer: 'CellRendererDate',
    filterParams: dateFilterParams,
    sort: 'desc',
  },
  {
    headerName: 'ORARaterName',
    headerClass: 'header-text-wrap',
    field: 'CommercialProductName',
    tooltipField: 'CommercialProductName',
    tooltipComponentParams: { field: 'CommercialProductName' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'OldPremium',
    headerClass: 'header-text-wrap',
    field: 'OldPremium',
    tooltipField: 'OldPremium',
    tooltipComponentParams: {
      field: 'OldPremium',
      showCurrency: true,
    },
    filter: 'agTextColumnFilter',
    cellRenderer: 'CellRendererMasterValue',
    cellRendererParams(params) {
      return {
        unit: '€',
        unitPosition: 'start',
        returnFloat: true,
      }
    },
  },
  {
    headerName: 'NewPremium',
    headerClass: 'header-text-wrap',
    field: 'NewPremium',
    tooltipField: 'NewPremium',
    tooltipComponentParams: {
      field: 'NewPremium',
      showCurrency: true,
    },
    filter: 'agTextColumnFilter',
    cellRenderer: 'CellRendererMasterValue',
    cellRendererParams(params) {
      return {
        unit: '€',
        unitPosition: 'start',
        returnFloat: true,
      }
    },
  },
  {
    headerName: 'InsuredSurname',
    headerClass: 'header-text-wrap',
    field: 'InsuredSurname',
    tooltipField: 'InsuredSurname',
    tooltipComponentParams: { field: 'InsuredSurname' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'InsuredName',
    headerClass: 'header-text-wrap',
    field: 'InsuredName',
    tooltipField: 'InsuredName',
    tooltipComponentParams: { field: 'InsuredName' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'InsuredCompanyName',
    headerClass: 'header-text-wrap',
    field: 'InsuredCompanyName',
    tooltipField: 'InsuredCompanyName',
    tooltipComponentParams: { field: 'InsuredCompanyName' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'FiscalCode',
    headerClass: 'header-text-wrap',
    field: 'FiscalCode',
    tooltipField: 'FiscalCode',
    tooltipComponentParams: { field: 'FiscalCode' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'VATCode',
    headerClass: 'header-text-wrap',
    field: 'VATCode',
    tooltipField: 'VATCode',
    tooltipComponentParams: { field: 'VATCode' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'CompanyProducerName',
    headerClass: 'header-text-wrap',
    field: 'CompanyProducerName',
    tooltipField: 'CompanyProducerName',
    tooltipComponentParams: { field: 'CompanyProducerName' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'User',
    headerClass: 'header-text-wrap',
    field: 'SubmitterName',
    tooltipField: 'SubmitterName',
    tooltipComponentParams: { field: 'SubmitterName' },
    filter: 'agTextColumnFilter',
    minWidth: 200,
  },
  {
    headerName: 'QuoteNumber',
    headerClass: 'header-text-wrap',
    field: 'QuoteNumber',
    tooltipField: 'QuoteNumber',
    tooltipComponentParams: { field: 'QuoteNumber' },
    filter: 'agTextColumnFilter'
  },
  {
    headerName: 'CompanyProducerCode',
    headerClass: 'header-text-wrap',
    field: 'CompanyProducerCode',
    tooltipField: 'CompanyProducerCode',
    tooltipComponentParams: { field: 'CompanyProducerCode' },
    filter: 'agTextColumnFilter'
  },
];
